module.exports = __webpack_public_path__ + "img/cup-2.31b77984.png";